
import {PaymentNotificationRenderer} from './drive/notifications/payment-notification-renderer';

const paymentNotification = 'App\\Notifications\\PaymentNotification';

export const SiteConfig = {
  homepage: {
    options: [{label: 'Landing page', value: 'landingPage'}],
  },
  tags: {
    types: [{name: 'label', system: true}],
  },
  notifications: {
    renderMap: {
      [paymentNotification]: PaymentNotificationRenderer,
    },
  },
};
